import { useState } from 'react';
import type { FormEvent } from 'react';

export function Feedback({ onSend, onClose }: { onSend: (text: string, rating: number) => Promise<void>; onClose: () => void }) {
  const [text, setText] = useState('');
  const [rating, setRating] = useState(3);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    try { await onSend(text, rating); onClose(); }
    catch (failure) { setError(failure instanceof Error ? failure.message : 'Не удалось отправить. Попробуй ещё раз.'); }
    finally { setBusy(false); }
  };
  return <div className="modal-backdrop"><form className="feedback-modal panel" onSubmit={(event) => void submit(event)}>
    <button type="button" className="close-button" onClick={onClose} aria-label="Закрыть">×</button>
    <span className="eyebrow">ПОЛЕВОЙ ТЕСТ</span><h2>Как ощущается полёт?</h2>
    <div className="rating" aria-label="Оценка впечатления">{[1, 2, 3, 4, 5].map((value) => <button key={value} type="button" aria-label={`Оценка ${value}`} className={value <= rating ? 'selected' : ''} onClick={() => setRating(value)}>★</button>)}</div>
    <textarea aria-label="Текст обратной связи" maxLength={4000} rows={4} value={text} onChange={(event) => setText(event.target.value)} placeholder="Что улучшить?" autoFocus />
    {error && <p className="form-error" role="alert">{error}</p>}
    <button className="launch-button" type="submit" disabled={busy || !text.trim()}>{busy ? 'Сохраняем…' : 'Отправить отзыв'} <span>↗</span></button>
  </form></div>;
}
